module.exports = __webpack_public_path__ + "static/media/website_logo_192.57a8b03c.png";